module.exports = {
  Direction: "ltr",
  Header: [
    { label: "Business Page" },
    { label: "Journal" },
    { label: "Services" },
    { label: "Customers" },
    { label: "Staff" },
    { label: "Settings" },
    { label: "Buy Subscription" },
    { label: "LogOut" },
    { label: "Do you want to log out?" },
    { label: "OK" },
    { label: "Cancel" },
  ],
  BusinessPage: [
    { label: "Sorry, server error, the page cannot be loaded" },
    { label: "Management panel" },
    { label: "Make an appointment now" },
    { label: "Share the business page" },
    {
      label: {
        item: "Click here to copy the link",
        item2: "The link has been copied!",
      },
    },
    { label: "Our stories" },
    { label: "Our services" },
    { label: "Product Description" }, // ServiceCard
    {
      label: {
        item: "Your appointment details",
        item2: "Hello:",
        item3: "Scheduled queue time:",
        item4: "Scheduled date:",
        item5: "Cancelling the appointment",
        item7: "No appointments have been made recently",
      },
    }, // UserQueueManagementMenu
    {
      label: {
        item: "Registration",
        item2: "Login",
        item3: "First name",
        item4: "Phone",
        item5: "Login",
        item7: "Registration to the system",
      },
    }, // UserLoginForm
    {
      label: {
        item: "You need to choose one favorite team member",
        item2: "You must choose at least one type of service",
        item3: "Must choose a date",
        item4: "It is necessary to select a time",
        item5: "Making an appointment",
        item7: "Set the queue?",
        item8: "Next",
        item9: "Your turn has been set successfully!",
        item10: "Back to page",
      },
    }, // BookAppointment
    {
      label: {
        item: "Select team member:",
        item2: "Select service type:",
        item3: "$", //price
        item4: "Select a date:",
        item5: "Select a time",
        item7: "All queues were taken on this date",
        item8: "Selected queue details:",
        item9: "Type of service",
        item10: "Date",
        item11: "Day",
        item12: "Hour",
        item13: "The selected employee",
      },
    }, // AppointmentFormSteps

    { label: "Open an appointment page for your business too!" },
  ],
  CalendarPage: [
    { label: "Are you sure to move the queue times?" },
    { label: { item: "Confirm", item2: "Cancel", item3: "Cancel queue" } },
    { label: "All" }, // setSelectedEmployeeViewQueue
    { label: "en" }, // culture
    { label: "left" }, // textAlign
    {
      label: {
        item: "Date of appointment",
        item2: "Queue time",
        item3: "Event type",
        item4: "No appointments found between these months",
      },
    }, // messages
    { label: "Share the business page" },
    { label: "Adding a new queue" },
    {
      label: {
        item: "Select an employee to display his queues",
        item2: "Select an employee",
        item3: "Everything",
        item4: "Daily date",
        item5: "Weekly date",
        item7: "Back to today",
      },
    }, // CustomToolbar
    {
      label: {
        item: "Are you sure you want to cancel the customer's queue",
        item2: "Queue details",
        item3: "Customer Name:",
        item4: "Queue time:",
        item5: "Queue end:",
        item7: "Making changes",
        item8: "Edit",
        item9: "Cancellation",
        item10: "Faucets",
      },
    }, // EventComponent
    {
      label: {
        item: "Date & time selection",
        item2: "Type of service",
        item3: "Customer name",
        item4: "Choosing up to an hour",
        item5: "Choosing a color to identify events",
        item7: "Choosing a color to identify the type of event",
        item8: "Choosing a color to identify the event",
        item9: "OK",
      },
    }, // AddEvents
  ],
  SettingsPage: [
    { label: "Working hours" },
    { label: "Setting the queues" },
    { label: "Designing the appointment page" },
    { label: "Managing pop-up messages" },
    { label: "Updates & reminders" },
    { label: "Business details" },
    { label: "Subscription details" },
    { label: "Language settings" },
    { label: "Important messages for customers" },
    { label: "Back to main page" },
  ],

  DropZoneArea: [
    { label: "The files that have already been received successfully:" },
    { label: "Total files received:" },
    {
      label:
        "Drag and drop files here to upload. We can only accept files smaller than 30MB.",
    },
    { label: "Select file" },
    { label: "Product description image number" },
    { label: "OK" },
    { label: "Viewing existing data" },
    { label: "Choosing the color of the page" },
    { label: "Execute" },
    { label: "Logo" },
    { label: "Page background image" },
    { label: "Photo stories" },
    { label: "Product images" },
    {
      label:
        "You can delete stories and product images by clicking on the desired image",
    },
    { label: "Are you sure you want to delete this image?" },
    { label: "Delete" },
    { label: "Cancel" },
  ],

  // components of settings

  WorkingHoures: [
    { label: "Day" },
    { label: "Beginning" },
    { label: "End" },
    { label: "Cancellation" },
    { label: "Time interval between queues:" },
    { label: "Make changes" },
  ],

  SubTitles: [
    {
      title: "Setting up appointments page settings",
      description: "Choose how you want the system to work",
    },
    {
      title: "Defining the system language",
      description: "Choose how you want the system to work",
    },
    {
      title: "Popup message content settings",
      description: "Choose how you want the pop-up messages to work",
      onLabel: "ON",
      offLabel: "Off",
      TextArea: "Content of pop-up message...",
      Label: "Perform",
    },
    {
      title: "Update settings and reminders for customers",
      description: "All customers in the system will receive a message",
      TextArea: "Message content...",
      Label: "Sending a message",
    },
    {
      title: "Personal area of ​​your subscription information",
      TextInput: "Next billing date",
      Label: "Unsubscribe",
      ModalTitle: "Are you sure you want to unsubscribe?",
      confirm: "confirmation",
      cancel: "Cancellation",
    },
  ],

  TypesOfServices: [
    { label: "Records per page" },
    { label: "No services added" },
    { label: "Service name" },
    { label: "Service time" },
    { label: "Service price" },
    { label: "$" },
    {
      label: {
        item: "Editing the selected service",
        item2: "Service name",
        item3: "Length of service time",
        item4: "Service price",
        item5: "The type of color is specific to the type of service",
        item7: "Active",
        item8: "Off",
        item9: "Hide the service from the appointment page",
        item10: "Are you sure you want to delete the customer from the system?",
        item11: "This operation will delete all the user's data",
        item12: "Delete",
        item13: "Cancellation",
        item14: "Deleting the service",
        item15: "Update details",
      },
    }, // DataEditing
  ],
  CustomersList: [
    { label: "Records per page" },
    { label: "No customers exist" },
    { label: "Customer name" },
    { label: "Customer rating" },
    { label: "No existing data" },
    {
      label: {
        item: "Customer details",
        item2: "Additional actions",
        item3: "Customer data",
        item4: "Customer name",
        item5: "Phone",
        item7: "Active",
        item8: "Off",
        item9: "Client blocking",
        item10: "Are you sure you want to delete the customer from the system?",
        item11: "This operation will delete all the user's data",
        item12: "Delete",
        item13: "Cancellation",
        item14: "Deleting the customer from the system",
        item15: "Update details",
        item16: "Delays:",
        item17: "Cancellations:",
        item18: "Meetings:",
      },
    }, // DataEditing
  ],
  ListMembers: [
    { label: "Records per page" },
    { label: "No existing employees" },
    { label: "Employee name" },
    { label: "Phone number" },
    { label: "Adding an employee" },
    {
      label: {
        item: "You chose",
        item2: "to remove one employee",
        item3: "Working for removal",
        item4: "Selecting an employee record to remove",
      },
    },
    {
      label: {
        item: "Employee tab editing",
        item2: "details",
        item3: "Working hours",
        item4: "Employee name",
        item5: "Phone",
        item7: "Active",
        item8: "Off",
        item9: "Cancellation of appointments for this employee",
        item11: "Update details",
      },
    }, // FormModal
    {
      label: {
        item: "Adding an employee to the system",
        item2: "Employee name",
        item3: "Phone",
        item4: "OK",
      },
    }, // FormAddEmployee
  ],
  SubscriptionPurchasePage: [
    { label: "30$ including VAT" },
    { label: "Branding and design of the business page" },
    { label: "Smart system for making appointments" },
    { label: "Customer rating and statistics" },
    { label: "Managing automatic messages to customers" },
    { label: "Digital diary" },
  ],
  PaymentSummaryPage: [
    { label: "The payment was successfully made" },
    { label: "Reconnect" },
    { label: "We apologize, but the payment did not go through successfully" },
    { label: "Try to make a payment again" },
  ],
  ExpiredZone: [
    { label: "Your subscription has expired" },
    { label: "In order to continue you must renew the subscription" },
    { label: "Expired" },
    { label: "Subscription expired" },
    { label: "Oops.. It looks like your subscription needs to be renewed 😄" },
    { label: "To renew the subscription" },
  ],
  CreateBusinessAccount: [
    { label: "First name and last name must include at least 6 letters" },
    { label: "Phone number must contain at least ten digits including prefix" },
    { label: "The password must contain at least 7 characters" },
    { label: "It is necessary to confirm privacy policy" },
    { label: "Invalid email" },
    { label: "Creating a user" },
    {},
    {
      inputs: {
        item: "First name and last name",
        item2: "Phone number",
        item3: "Email",
        item4: "Password",
        item5: "I confirm",
        item7: "The terms and privacy policy",
        item8: "Business profile",
        item9: "Business phone",
        item10: "Business name",
        item11: "Business address",
        item12: "Type of color for your business page",
        item13: "Determining the queues",
        item14: "Add services",
        item15: "Return",
        item17: "Next step",
        item18: "Creating the business page",
        //AddNewtodoList.js
        item19: "Type of service",
        item20: "Service time",
        item21: "Price",
        item22: "Click the button to add a service",
        item23: "It is necessary to add at least one service",
        item24: "Add service",
      },
    },
    // SuccessPages/SuccessCreateAccount
    { label: "We have finished setting up your queue management page!" },
    { label: "connect to the system" },
  ],
  MainPage: [
    { label: "Login" },
    { label: "Creating an account" },
    {
      inputs: {
        item: "Phone number",
        item2: "Password",
        item3: "Log in",
        item4: "Privacy Policy",
      },
    },
  ],
  PaymentMethodDetailCard: [
    { label: "Smart Digital Appointment Diary" },
    { label: "Branded Business Page for 24/7 Bookings" },
    { label: "Automated WhatsApp Reminders to Clients" },
    { label: "Upfront Payment Collection from Clients" },
    { label: "Automatic Digital Receipts" },
    { label: "Client Management & Ratings" },
    { label: "Performance Analytics & Statistics" },
    { label: "Product Inventory Management" },
    { label: "Treatment Series & Packages" },
    { label: "Smart Waiting List" },
    { label: "Unlimited Staff & Team Members" },
    { label: "Try free for 14 days" },
    {
      inputs: {
        item: "Phone Number",
        item2: "Password",
        item3: "Login",
        item4: "Privacy Policy",
      },
    },
  ],

  ContactSection: [
    { title: "Contact details" },
    { Email: "Email" },
    { Phone: "Phone" },
    { Address: "Office address" },
    { WorkingHours: "Working hours" },
  ],
};
